__turbopack_context__.v({
  "close": "k98I1a_close",
  "confirm": "k98I1a_confirm",
  "content": "k98I1a_content",
  "mask": "k98I1a_mask",
  "modal": "k98I1a_modal",
  "modalFadeIn": "k98I1a_modalFadeIn",
  "overlay": "k98I1a_overlay",
  "primary": "k98I1a_primary",
  "primary-button": "k98I1a_primary-button",
  "secondary": "k98I1a_secondary",
  "secondary-link": "k98I1a_secondary-link",
  "urlViewMore": "k98I1a_urlViewMore",
});
